import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { nanoid } from "nanoid";
import axios from "axios";
const API_URL = "https://seg.a2hosted.com";

function DryersPageComp() {
  const [productTitle, setProductTitle] = useState("");
  const [productPrice, setProductPrice] = useState("");
  const [productModel, setProductModel] = useState("");
  const [productAge, setProductAge] = useState("");
  const [productPower, setProductPower] = useState("");
  const [productWeight, setProductWeight] = useState("");
  const [productDesc, setProductDesc] = useState("");
  const [productFOB, setProductFOB] = useState("");
  const [productImgArray, setProductImgArray] = useState([]);

  // Product Array Layout
  // {
  //   pTitle: "Test Title",
  //   pPrice: "Test 1000.00$",
  //   pModel: "Model",
  //   pAge: "Test Age",
  //   pPower: "Test Power Req",
  //   pWeight: "99999lb",
  //   pDesc: "Test Desc",
  //   pImgs: ["./images/products/Wascomat/1-14-2023-E620-20lb/1.jpg"],
  // },

  const [dexterProducts, setDexterProducts] = useState([]);

  useEffect(() => {
    const url = `${API_URL}/ProductJson/DexterDryerProducts`;

    axios
      .get(url)
      .then(function (response) {
        console.log(response.data);
        setDexterProducts(response.data);
      })
      .catch(function (error) {
        setDexterProducts([]);
      });
  }, []);

  const [wascomatProducts, setWascomatProducts] = useState([]);

  useEffect(() => {
    const url = `${API_URL}/ProductJson/WascomatDryerProducts`;

    axios
      .get(url)
      .then(function (response) {
        console.log(response.data);
        setWascomatProducts(response.data);
      })
      .catch(function (error) {
        setWascomatProducts([]);
      });
  }, []);

  const [uniMacProducts, setUniMacProducts] = useState([]);

  useEffect(() => {
    const url = `${API_URL}/ProductJson/UnimacDryerProducts`;

    axios
      .get(url)
      .then(function (response) {
        console.log(response.data);
        setUniMacProducts(response.data);
      })
      .catch(function (error) {
        setUniMacProducts([]);
      });
  }, []);

  const [maytagProducts, setMaytagProducts] = useState([]);

  useEffect(() => {
    const url = `${API_URL}/ProductJson/MaytagDryerProducts`;

    axios
      .get(url)
      .then(function (response) {
        console.log(response.data);
        setMaytagProducts(response.data);
      })
      .catch(function (error) {
        setMaytagProducts([]);
      });
  }, []);

  // Milnor
  const [milnorProducts, setMilnorProducts] = useState([]);

  useEffect(() => {
    const url = `${API_URL}/ProductJson/MilnorDryerProducts`;

    axios
      .get(url)
      .then(function (response) {
        console.log(response.data);
        setMilnorProducts(response.data);
      })
      .catch(function (error) {
        setMilnorProducts([]);
      });
  }, []);

  // Electrolux
  const [electroluxProducts, setElectroluxProducts] = useState([]);

  useEffect(() => {
    const url = `${API_URL}/ProductJson/ElectroluxDryerProducts`;

    axios
      .get(url)
      .then(function (response) {
        console.log(response.data);
        setElectroluxProducts(response.data);
      })
      .catch(function (error) {
        setElectroluxProducts([]);
      });
  }, []);

  // WhirlPool
  const [WhirlPoolProducts, setWhirlPoolProducts] = useState([]);

  useEffect(() => {
    const url = `${API_URL}/ProductJson/WhirlPoolDryerProducts`;

    axios
      .get(url)
      .then(function (response) {
        console.log(response.data);
        setWhirlPoolProducts(response.data);
      })
      .catch(function (error) {
        setWhirlPoolProducts([]);
      });
  }, []);

  // Ipso
  const [ipsoProducts, setIpsoProducts] = useState([]);

  useEffect(() => {
    const url = `${API_URL}/ProductJson/IpsoDryerProducts`;

    axios
      .get(url)
      .then(function (response) {
        console.log(response.data);
        setIpsoProducts(response.data);
      })
      .catch(function (error) {
        setIpsoProducts([]);
      });
  }, []);

  // Heubsch
  const [heubschProducts, setHeubschProducts] = useState([]);

  useEffect(() => {
    const url = `${API_URL}/ProductJson/HeubschDryerProducts`;

    axios
      .get(url)
      .then(function (response) {
        console.log(response.data);
        setHeubschProducts(response.data);
      })
      .catch(function (error) {
        setHeubschProducts([]);
      });
  }, []);

  // SpeedQueen
  const [speedQueenProducts, setSpeedQueenProducts] = useState([]);

  useEffect(() => {
    const url = `${API_URL}/ProductJson/SpeedQueenDryerProducts`;

    axios
      .get(url)
      .then(function (response) {
        console.log(response.data);
        setSpeedQueenProducts(response.data);
      })
      .catch(function (error) {
        setSpeedQueenProducts([]);
      });
  }, []);

  return (
    <>
      <div className="container bg-dark min-vh-100 rounded-5 p-2">
        <h2 className="display-2 text-white text-center fw-semibold text-shadow-pop-top">
          Commercial Laundry Equipment
        </h2>
        <p className="fs-1 text-white text-center fw-semibold text-shadow-1">
          ~Dryers~
          <br />
          <NavLink to={"/LaundryEquipment"} className={"text-decoration-none"}>
            <span className="fw-semibold btn btn-large btn-primary box-glow-1 border-0">Laundry Stuff Page</span>
          </NavLink>{" "}
        </p>
        <hr className="page-line" />
        {/* Dexter Equipment */}
        <h1 className="display-6 text-light fw-normal text-center">
          Brand: <span className="text-primary fw-semibold">Dexter</span>
        </h1>
        <div className="row text-white text-center justify-content-center mt-2 gy-3">
          {dexterProducts.map((productItem, Index) => {
            return (
              <div key={nanoid()} className="col-12 col-lg-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={() => {
                    setProductTitle(Index + ": " + productItem.pTitle); //Product Title
                    setProductPrice(productItem.pPrice); //Product Price (Don't Include $)
                    setProductModel(productItem.pModel);
                    setProductAge(productItem.pAge);
                    setProductWeight(productItem.pWeight);
                    setProductPower(productItem.pPower);
                    setProductFOB(productItem.pFOB);
                    setProductDesc(productItem.pDesc); //Product Desc
                    setProductImgArray(productItem.pImgs); // Path Relative to Index.html in public folder (./images/products/NAME)
                  }}
                >
                  Sku: {Index}. {productItem.pTitle}
                </button>
              </div>
            );
          })}
        </div>
        {/* Wascomat Equipment */}
        <h1 className="display-6 text-light fw-normal text-center">
          Brand: <span className="text-primary fw-semibold">WascoMat</span>
        </h1>
        <div className="row text-white text-center justify-content-center mt-2 gy-3">
          {wascomatProducts.map((productItem, Index) => {
            return (
              <div key={nanoid()} className="col-12 col-lg-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={() => {
                    setProductTitle(Index + ": " + productItem.pTitle); //Product Title
                    setProductPrice(productItem.pPrice); //Product Price (Don't Include $)
                    setProductModel(productItem.pModel);
                    setProductAge(productItem.pAge);
                    setProductWeight(productItem.pWeight);
                    setProductPower(productItem.pPower);
                    setProductFOB(productItem.pFOB);
                    setProductDesc(productItem.pDesc); //Product Desc
                    setProductImgArray(productItem.pImgs); // Path Relative to Index.html in public folder (./images/products/NAME)
                  }}
                >
                  Sku: {Index}. {productItem.pTitle}
                </button>
              </div>
            );
          })}
        </div>
        {/* UniMac Equipment */}
        <h1 className="display-6 text-light fw-normal text-center">
          Brand: <span className="text-primary fw-semibold">UniMac</span>
        </h1>
        <div className="row text-white text-center justify-content-center mt-2 gy-3">
          {uniMacProducts.map((productItem, Index) => {
            return (
              <div key={nanoid()} className="col-12 col-lg-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={() => {
                    setProductTitle(Index + ": " + productItem.pTitle); //Product Title
                    setProductPrice(productItem.pPrice); //Product Price (Don't Include $)
                    setProductModel(productItem.pModel);
                    setProductAge(productItem.pAge);
                    setProductWeight(productItem.pWeight);
                    setProductPower(productItem.pPower);
                    setProductFOB(productItem.pFOB);
                    setProductDesc(productItem.pDesc); //Product Desc
                    setProductImgArray(productItem.pImgs); // Path Relative to Index.html in public folder (./images/products/NAME)
                  }}
                >
                  Sku: {Index}. {productItem.pTitle}
                </button>
              </div>
            );
          })}
        </div>

        {/* MayTag Equipment */}
        <h1 className="display-6 text-light fw-normal text-center">
          Brand: <span className="text-primary fw-semibold">Maytag</span>
        </h1>
        <div className="row text-white text-center justify-content-center mt-2 gy-3">
          {maytagProducts.map((productItem, Index) => {
            return (
              <div key={nanoid()} className="col-12 col-lg-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={() => {
                    setProductTitle(Index + ": " + productItem.pTitle); //Product Title
                    setProductPrice(productItem.pPrice); //Product Price (Don't Include $)
                    setProductModel(productItem.pModel);
                    setProductAge(productItem.pAge);
                    setProductWeight(productItem.pWeight);
                    setProductPower(productItem.pPower);
                    setProductFOB(productItem.pFOB);
                    setProductDesc(productItem.pDesc); //Product Desc
                    setProductImgArray(productItem.pImgs); // Path Relative to Index.html in public folder (./images/products/NAME)
                  }}
                >
                  Sku: {Index}. {productItem.pTitle}
                </button>
              </div>
            );
          })}
        </div>
        {/* Milnor Equipment */}
        <h1 className="display-6 text-light fw-normal text-center">
          Brand: <span className="text-primary fw-semibold">Milnor</span>
        </h1>
        <div className="row text-white text-center justify-content-center mt-2 gy-3">
          {milnorProducts.map((productItem, Index) => {
            return (
              <div key={nanoid()} className="col-12 col-lg-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={() => {
                    setProductTitle(Index + ": " + productItem.pTitle); //Product Title
                    setProductPrice(productItem.pPrice); //Product Price (Don't Include $)
                    setProductModel(productItem.pModel);
                    setProductAge(productItem.pAge);
                    setProductWeight(productItem.pWeight);
                    setProductPower(productItem.pPower);
                    setProductFOB(productItem.pFOB);
                    setProductDesc(productItem.pDesc); //Product Desc
                    setProductImgArray(productItem.pImgs); // Path Relative to Index.html in public folder (./images/products/NAME)
                  }}
                >
                  Sku: {Index}. {productItem.pTitle}
                </button>
              </div>
            );
          })}
        </div>
        {/* SpeedQueen Equipment */}
        <h1 className="display-6 text-light fw-normal text-center">
          Brand: <span className="text-primary fw-semibold">SpeedQueen</span>
        </h1>
        <div className="row text-white text-center justify-content-center mt-2 gy-3">
          {speedQueenProducts.map((productItem, Index) => {
            return (
              <div key={nanoid()} className="col-12 col-lg-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={() => {
                    setProductTitle(Index + ": " + productItem.pTitle); //Product Title
                    setProductPrice(productItem.pPrice); //Product Price (Don't Include $)
                    setProductModel(productItem.pModel);
                    setProductAge(productItem.pAge);
                    setProductWeight(productItem.pWeight);
                    setProductPower(productItem.pPower);
                    setProductFOB(productItem.pFOB);
                    setProductDesc(productItem.pDesc); //Product Desc
                    setProductImgArray(productItem.pImgs); // Path Relative to Index.html in public folder (./images/products/NAME)
                  }}
                >
                  Sku: {Index}. {productItem.pTitle}
                </button>
              </div>
            );
          })}
        </div>
        {/* Electrolux Equipment */}
        <h1 className="display-6 text-light fw-normal text-center">
          Brand: <span className="text-primary fw-semibold">Electrolux</span>
        </h1>
        <div className="row text-white text-center justify-content-center mt-2 gy-3">
          {electroluxProducts.map((productItem, Index) => {
            return (
              <div key={nanoid()} className="col-12 col-lg-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={() => {
                    setProductTitle(Index + ": " + productItem.pTitle); //Product Title
                    setProductPrice(productItem.pPrice); //Product Price (Don't Include $)
                    setProductModel(productItem.pModel);
                    setProductAge(productItem.pAge);
                    setProductWeight(productItem.pWeight);
                    setProductPower(productItem.pPower);
                    setProductFOB(productItem.pFOB);
                    setProductDesc(productItem.pDesc); //Product Desc
                    setProductImgArray(productItem.pImgs); // Path Relative to Index.html in public folder (./images/products/NAME)
                  }}
                >
                  Sku: {Index}. {productItem.pTitle}
                </button>
              </div>
            );
          })}
        </div>
        {/* Whirlpool Equipment */}
        <h1 className="display-6 text-light fw-normal text-center">
          Brand: <span className="text-primary fw-semibold">Whirlpool</span>
        </h1>
        <div className="row text-white text-center justify-content-center mt-2 gy-3">
          {WhirlPoolProducts.map((productItem, Index) => {
            return (
              <div key={nanoid()} className="col-12 col-lg-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={() => {
                    setProductTitle(Index + ": " + productItem.pTitle); //Product Title
                    setProductPrice(productItem.pPrice); //Product Price (Don't Include $)
                    setProductModel(productItem.pModel);
                    setProductAge(productItem.pAge);
                    setProductWeight(productItem.pWeight);
                    setProductPower(productItem.pPower);
                    setProductFOB(productItem.pFOB);
                    setProductDesc(productItem.pDesc); //Product Desc
                    setProductImgArray(productItem.pImgs); // Path Relative to Index.html in public folder (./images/products/NAME)
                  }}
                >
                  Sku: {Index}. {productItem.pTitle}
                </button>
              </div>
            );
          })}
        </div>
        {/* Ipso Equipment */}
        <h1 className="display-6 text-light fw-normal text-center">
          Brand: <span className="text-primary fw-semibold">Ipso</span>
        </h1>
        <div className="row text-white text-center justify-content-center mt-2 gy-3">
          {ipsoProducts.map((productItem, Index) => {
            return (
              <div key={nanoid()} className="col-12 col-lg-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={() => {
                    setProductTitle(Index + ": " + productItem.pTitle); //Product Title
                    setProductPrice(productItem.pPrice); //Product Price (Don't Include $)
                    setProductModel(productItem.pModel);
                    setProductAge(productItem.pAge);
                    setProductWeight(productItem.pWeight);
                    setProductPower(productItem.pPower);
                    setProductFOB(productItem.pFOB);
                    setProductDesc(productItem.pDesc); //Product Desc
                    setProductImgArray(productItem.pImgs); // Path Relative to Index.html in public folder (./images/products/NAME)
                  }}
                >
                  Sku: {Index}. {productItem.pTitle}
                </button>
              </div>
            );
          })}
        </div>
        {/* Heubsch Equipment */}
        <h1 className="display-6 text-light fw-normal text-center">
          Brand: <span className="text-primary fw-semibold">Heubsch</span>
        </h1>
        <div className="row text-white text-center justify-content-center mt-2 gy-3">
          {heubschProducts.map((productItem, Index) => {
            return (
              <div key={nanoid()} className="col-12 col-lg-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={() => {
                    setProductTitle(Index + ": " + productItem.pTitle); //Product Title
                    setProductPrice(productItem.pPrice); //Product Price (Don't Include $)
                    setProductModel(productItem.pModel);
                    setProductAge(productItem.pAge);
                    setProductWeight(productItem.pWeight);
                    setProductPower(productItem.pPower);
                    setProductFOB(productItem.pFOB);
                    setProductDesc(productItem.pDesc); //Product Desc
                    setProductImgArray(productItem.pImgs); // Path Relative to Index.html in public folder (./images/products/NAME)
                  }}
                >
                  Sku: {Index}. {productItem.pTitle}
                </button>
              </div>
            );
          })}
        </div>
        {/* End of Products */}
      </div>
      {/* Pop up Window */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              {/* Popup Title */}
              <h1 className="modal-title fs-5 fw-bold" id="exampleModalLabel">
                Sku#{productTitle}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            {/* Popup Body */}
            <div className="modal-body">
              <p className="fs-5 fw-semibold">Price: ${productPrice}</p>
              <p className="fs-6 fw-semibold">Model: {productModel}</p>
              <p className="fs-6 fw-semibold">Age: {productAge}</p>
              <p className="fs-6 fw-semibold">Approx Weight:{productWeight}</p>
              <p className="fs-6 fw-semibold">Power Req: {productPower}</p>
              <p className="fs-6 fw-semibold">F.O.B: {productFOB}</p>
              <p className="fs-6 fw-semibold">Desc: {productDesc}</p>
              <p className="fs-6 fw-bolder">
                Contact For Shipping Quote and to Purchase.
              </p>
              <div id="carouselExample" className="carousel slide">
                <div className="carousel-inner">
                  {productImgArray.map((imgSrc, Index) => {
                    if (Index === 0) {
                      return (
                        <div key={nanoid()} className="carousel-item active">
                          <img
                            src={imgSrc}
                            className="d-block w-100"
                            alt="Product Img"
                          />
                        </div>
                      );
                    } else {
                      return (
                        <div key={nanoid()} className="carousel-item">
                          <img
                            src={imgSrc}
                            className="d-block w-100"
                            alt="Product Img"
                          />
                        </div>
                      );
                    }
                  })}
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#carouselExample"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  />
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#carouselExample"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  />
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DryersPageComp;
